/* eslint no-extend-native: 0 */
import 'core-js'

console.log('Load polyfills')